import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=5afaae59&scoped=true"
import script from "./autocomplete.vue?vue&type=script&lang=js"
export * from "./autocomplete.vue?vue&type=script&lang=js"
import style0 from "./autocomplete.vue?vue&type=style&index=0&id=5afaae59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afaae59",
  null
  
)

export default component.exports